import { render, staticRenderFns } from "./h5Index.vue?vue&type=template&id=1fcd5f78&scoped=true"
import script from "./h5Index.vue?vue&type=script&lang=js"
export * from "./h5Index.vue?vue&type=script&lang=js"
import style0 from "./h5Index.vue?vue&type=style&index=0&id=1fcd5f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcd5f78",
  null
  
)

export default component.exports